import { Component, OnInit } from '@angular/core';
import { News } from '@app/models/news';
import { FamilyService, NewsService } from '@app/services';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { mergeMap, switchMap, takeUntil, map, distinctUntilChanged } from 'rxjs/operators';
import { Observable, Subject, of, combineLatest } from 'rxjs';

@Component({
  selector: 'app-news-by-category',
  templateUrl: './news-by-category.component.html',
  styleUrls: ['./news-by-category.component.scss'],
  standalone: false
})
export class NewsByCategoryComponent implements OnInit {

  newsList: News[];
  loading: boolean;
  destroy$ = new Subject<void>();

  constructor(
    private newsService: NewsService,
    private familyService: FamilyService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    const categoriesId$: Observable<string> = this.route.paramMap.pipe(
      takeUntil(this.destroy$),
      map((params: ParamMap) => params.get('idCategories').split('-').toString()),
      distinctUntilChanged()
    );

    const familyVars$: Observable<Object> = this.familyService.currentFamilyChange$.pipe(
      takeUntil(this.destroy$),
      switchMap(fam => fam ? this.familyService.getFamilyVariables(fam.id) : of({}))
    )

    combineLatest([categoriesId$, familyVars$]).subscribe(([categoriesIds, familyVars]: [string, any]) => {

      this.loading = true;

      this.newsService.getNewsByCategory(categoriesIds).subscribe((data: News[]) => {
        this.newsList = data.filter(news => {
          let etbAcc = []
          try {
            etbAcc = JSON.parse(news.etablissementAccueil)
          } catch (error) {
            // Non rien, c'est juste pour eviter un plantage
            // sur le JSON.Parse si le JSON n'est pas valide ...
            // mais comme 'etbAcc' est déjà initialisé avec un tableau vide , on ne fait rien de spécial
          }
          return !news.isPrivate || !etbAcc.length || etbAcc.filter(etb => familyVars.etablissementAccueil?.find(
            etab => etab.idEtablissement == etb.etablissmentId && etb.accueils.some(acc => etab.accueils.includes(acc))
          )).length
        });

        setTimeout(() => { // delay to let time for route animation to finish
          this.loading = false;
        }, 350)
      });
    });
  }



}
